const base = 'https://res.cloudinary.com/fxtr/image/upload';

const mapping = {
  '3M': '/v1627907766/brands-eng/3M_ftlx11.png',
  Airtex: '/v1627907766/brands-eng/Airtex_zpotbd.png',
  Aisin: '/v1627907765/brands-eng/Aisin_bfg7iq.png',
  ATE: '/v1627907766/brands-eng/Ate_pick2t.png',
  BehrHella: '/v1627907766/brands-eng/BehrHella_layipw.png',
  BERU: '/v1627907766/brands-eng/BERU_ujsxxi.png',
  Bilstein: '/v1627907766/brands-eng/Bilstein_geiodb.png',
  Bosch: '/v1627907767/brands-eng/Bosch_uk50qn.png',
  Bougicord: '/v1627907766/brands-eng/Bougicord_d7k4hf.png',
  Brembo: '/v1627907766/brands-eng/Brembo_vj8fmu.png',
  Bremi: '/v1627907768/brands-eng/Bremi_fspfqn.png',
  Caastrol: '/v1627907767/brands-eng/Caastrol_yygjzr.png',
  Continental: '/v1627907767/brands-eng/Continental_v7j345.png',
  Corteco: '/v1627907767/brands-eng/Corteco_iz48ug.png',
  CroslandFilters: '/v1627907767/brands-eng/CroslandFilters_gsounl.png',
  Dayco: '/v1627907767/brands-eng/Dayco_opfmb5.png',
  Delphi: '/v1627907768/brands-eng/Delphi_vh7kcq.png',
  Denso: '/v1627907768/brands-eng/Denso_o2pp6f.png',
  Duracell: '/v1627907768/brands-eng/Duracell_zq4oju.png',
  Exedy: '/v1627907769/brands-eng/Exedy_gp5dns.png',
  Elring: '/v1627907768/brands-eng/Elring_rsge1c.png',
  Exide: '/v1627907769/brands-eng/Exide_vkqlug.png',
  FAG: '/v1627907769/brands-eng/FAG_h5kmtn.png',
  FebiBilstein: '/v1627907769/brands-eng/FebiBilstein_asxgcm.png',
  FTE: '/v1627907769/brands-eng/FTE_gfkih3.png',
  Garrett: '/v1627907770/brands-eng/Garrett_dfmori.png',
  Gulf: '/v1627907769/brands-eng/Gulf_mlm15d.png',
  Hella: '/v1627907770/brands-eng/Hella_jcuuz1.png',
  Henkel: '/v1627907770/brands-eng/Henkel_ltdxbh.png',
  Hidria: '/v1627907770/brands-eng/Hidria_ihvygv.png',
  INA: '/v1627907770/brands-eng/INA_qnjebt.png',
  'KK&K': '/v1627907770/brands-eng/KK_K_wuhon0.png',
  Klarius: '/v1627907771/brands-eng/Klarius_zyzj2z.png',
  Koyo: '/v1627907771/brands-eng/Koyo_ujf0zb.png',
  KWP: '/v1627907771/brands-eng/KWP_pkf1dp.png',
  KYB: '/v1627907771/brands-eng/KYB_gi0vmd.png',
  Lemforder: '/v1627907771/brands-eng/Lemforder_ttdxh0.png',
  Lucas: '/v1627907772/brands-eng/Lucas_bh78yl.png',
  LUK: '/v1627907772/brands-eng/LUK_dpykks.png',
  MagnetMarelli: '/v1627907772/brands-eng/MagnetMarelli_i6ngyc.png',
  Mahle: '/v1627907772/brands-eng/Mahle_euhbvt.png',
  MannFilter: '/v1627907772/brands-eng/MannFilter_czed3o.png',
  Milwaukee: '/v1627907772/brands-eng/Milwaukee_rgxky8.png',
  Mobil: '/v1627907772/brands-eng/Mobil_kv8tjl.png',
  Moog: '/v1627907772/brands-eng/Moog_v3m9gn.png',
  NGK: '/v1627907773/brands-eng/NGK_lfjapp.png',
  Normfest: '/v1627907772/brands-eng/Normfest_ecxvvm.png',
  NTK: '/v1627907773/brands-eng/NTK_nsy1hh.png',
  NTNSNR: '/v1627907773/brands-eng/NTNSNR_qsedst.png',
  Osram: '/v1627907774/brands-eng/Osram_znodgu.png',
  Pagid: '/v1627907774/brands-eng/Pagid_u9k5v9.png',
  Pertronas: '/v1627907773/brands-eng/Pertronas_umy54e.png',
  Philips: '/v1627907773/brands-eng/Philips_b1eodh.png',
  Pierburg: '/v1627907773/brands-eng/Pierburg_psaehs.png',
  Remy: '/v1627907774/brands-eng/Remy_hbcxmz.png',
  Ruville: '/v1627907774/brands-eng/Ruville_ci3go5.png',
  SACHS: '/v1627907774/brands-eng/SACHS_yaqasw.png',
  Shell: '/v1627907774/brands-eng/Shell_nlxfqu.png',
  SKF: '/v1627907774/brands-eng/SKF_kxdmrt.png',
  Starline: '/v1627907774/brands-eng/Starline_jxxpab.png',
  Textar: '/v1627907774/brands-eng/Textar_gzb3z0.png',
  Turbojetzt: '/v1627907775/brands-eng/Turbojetzt_qywppr.png',
  Transmech: '/v1627907775/brands-eng/Transmech_t9o4kg.png',
  Tripleqx: '/v1627907775/brands-eng/TripleQX_lo5lay.png',
  TRW: '/v1627907775/brands-eng/TRW_i0xc0w.png',
  Valeo: '/v1627907775/brands-eng/Valeo_gprkx9.png',
  Varta: '/v1627907776/brands-eng/Varta_rcga0t.png',
  VDO: '/v1627907775/brands-eng/VDO_ek3nlx.png',
  Wahler: '/v1627907775/brands-eng/Wahler_ba8hmj.png',
  ZF: '/v1627907776/brands-eng/ZF_gsu7hx.png',
};

Object.entries(mapping).forEach(([key, value]) => {
  mapping[key] = base + value;
});

const brandsImgMapping = mapping;

export default brandsImgMapping;
